<template>
  <div class="bidder-page">
    <!-- 搜索区域 -->
    <div class="search-section">
        <el-form :model="searchForm" :inline="true" class="search-form">
          <el-form-item>
            <el-input v-model="searchForm.sectionName" placeholder="标段名称" clearable style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading"
        :empty-text="loading ? '加载中...' : '暂无数据'">
        <el-table-column prop="bidInviteName" label="邀请书名称" min-width="200">
          <template slot-scope="scope">
            <div>
              <el-link type="primary" :underline="false">{{ scope.row.bidInviteName }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="150"></el-table-column>
        <el-table-column prop="projectCode" label="项目编号" min-width="150"></el-table-column>
        <el-table-column prop="bidSectionName" label="标段名称" min-width="200"></el-table-column>
        <el-table-column prop="bidSectionCode" label="标段编号" min-width="200"></el-table-column>

        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">进入流程</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { confirmedPaidSections} from '@/api/InvitationLetter/api'
export default {
  data() {
    return {
      searchForm: {
        bidSectionName: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      tableData: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {



    loadData() {
      this.confirmedPaidSections()
    },

    confirmedPaidSections() {
      this.loading = true
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        bidSectionName: this.searchForm.bidSectionName
      }
      confirmedPaidSections(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '获取数据失败')
        }
      }).catch(error => {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    handleView(row) {
      console.log('查看详情:', row)
      this.$router.push({ path: '/bidderHome/bidderFlow',query: { sectionCode: row.bidSectionCode } })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-page {
  .apply-minimal-gray-theme();
}

.upload-bid-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0;
}


.banner-content {
  color: white;
  font-size: 14px;
  line-height: 1.5;
}

.page-card {
  min-height: calc(100vh - 120px);
  box-shadow: none;
  border: 1px solid #e8e8e8;
}

.search-section {
  text-align: start;
  flex-shrink: 0;
  margin-bottom: 10px;
}

.search-form {
  margin: 0;
}

.pagination-section {
  margin-top: 20px;
  text-align: right;
  padding-bottom: 20px;
}

.el-table {
  font-size: 14px;
  width: 100% !important;
}

.el-table th {
  font-weight: 600;
}

.el-link {
  font-size: 14px;
}

/* 公告标签样式 */
.announcement-tag {
  color: #1890ff;
  font-size: 12px;
  margin-top: 4px;
}

/* 电子评标标签样式 */
.evaluation-tag {
  margin-left: 8px;
  font-size: 12px;
}

/* 确保分页不遮挡内容 */
.upload-bid-page {
  padding-bottom: 60px;
}

.page-card {
  margin-bottom: 20px;
}
</style>
